import { useEffect, useState } from 'react';
import {
  PARALLAX_GAP_ATTACH_RAF_MAX,
  PARALLAX_GAP_CREATIVE_DETECT_MS
} from './constants';
import {
  BannerCreative,
  extractBannerCreative,
  waitForElementById
} from './helpers';

export const useParallaxCreative = (
  shouldRunBanner: boolean,
  containerId: string
) => {
  const [creative, setCreative] = useState<BannerCreative | null>(null);

  useEffect(() => {
    if (!shouldRunBanner) {
      setCreative(null);
      return;
    }

    setCreative(null);

    let observer: MutationObserver | null = null;
    const watchdog = window.setTimeout(() => {
      setCreative(null);
    }, PARALLAX_GAP_CREATIVE_DETECT_MS);

    const readCreative = () => {
      const next = extractBannerCreative(containerId);
      if (!next) return false;
      setCreative(next);
      return true;
    };

    const cancelWait = waitForElementById(
      containerId,
      container => {
        if (readCreative()) {
          window.clearTimeout(watchdog);
          return;
        }
        observer = new MutationObserver(() => {
          if (!readCreative()) return;
          window.clearTimeout(watchdog);
          observer?.disconnect();
        });
        observer.observe(container, { childList: true, subtree: true });
      },
      PARALLAX_GAP_ATTACH_RAF_MAX
    );

    return () => {
      window.clearTimeout(watchdog);
      cancelWait();
      observer?.disconnect();
    };
  }, [shouldRunBanner, containerId]);

  return creative;
};
